// update along with app/lib/enums/export_type.py
const ExportType = {
  PRODUCT_EXPORT: 0,
  TAXONOMY_EXPORT: 1,
  ATTRIBUTE_EXPORT: 2,
  ATTRIBUTE_IMPORT_ERRORS: 3,
  PRIORITY_EXPORT: 4,
  FSA_SKU_MAPPINGS_EXPORT: 5,
  ALL_ATTRIBUTE_EXPORT: 6,
  BRAND_WITH_UPB_SCORES_EXPORT: 7,
  BRAND_DETAILS_EXPORT: 8,
  MANUFACTURER_DETAILS_EXPORT: 9,
  UPB_MATCH_PERCENTAGE_EXPORT: 10,
  SCHEMA_ATTRIBUTES_EXPORT: 11,
  PRODUCT_OUTLIER_CHANGES_EXPORT: 12,
  DATA_SOURCE_PREPROCESSED_EXPORT: 13,
  ONE_TIME_EXPORT: 14,
  BRAND_ACTIVITY_REPORT_EXPORT: 15,
  CD_THUMBNAIL_EXPORT: 16,
  VENDOR_DETAILS_EXPORT: 17,
  MANUFACTURER_PORTAL_PRODUCT_EXPORT: 18,
  BRAND_CONTENT_QA_REPORT: 19,
  USER_TIME_LOGS_REPORT: 20,
  SIMILAR_BRAND_NAMES_QA_REPORT: 21,
  MANUFACTURER_BRAND_PRODUCT_EXPORT: 22,
  GDSN_MANUFACTURER_PRODUCT_EXPORT: 23,
  PRODUCT_LIST_UNASSIGNED_ATTRIBUTES_EXPORT: 24,
  MANUFACTURER_SKU_CLEAN_UP_REPORT: 25,
  MANUFACTURER_PRODUCT_ENRICHMENT: 26,
  USER_PAYMENT_INFO_REPORT: 27,
  USER_THROUGHPUT_REPORT: 28,
  USER_INVOICE_REPORT: 29,
  ENGAGED_MANUFACTURER_SCORES_EXPORT: 30,
  MANUFACTURERS_GLN_STATUS_ASSOCIATED_WITH_A_VENDOR: 31,
  PRODUCT_DATA_WITH_GMV_AND_MAPPING: 32,
  BRAND_DP_PRODUCTS_REPORT: 33,
  ENGAGED_MANUFACTURERS_GMV_REPORT: 34,
  DISTRIBUTORS_GMV_REPORT: 35,
  UNMAPPED_GMV_PRODUCTS_REPORT: 38,
  DP_PRODUCTS_BRAND_REPORT: 39,
  UNSTRUCTURED_GMV_PRODUCTS_REPORT: 40,
  L4_LARGE_CATEGORIES_EXPORT: 41,
  L4_CATEGORY_PRODUCTS_EXPORT: 42,
  MANUFACTURER_ENGAGEMENT_REPORT: 43,
  MFR_SCORE_GAP_REPORT: 44,
  MFR_SCORE_GAP_CUSTOMER_REPORT: 45,
  L4_SEGMENTATION_VIEW_EXPORT: 46,
  L4_RESEGMENTATION_VIEW_EXPORT: 47,
  L4_RESEGMENTATION_ERROR_REPORT: 48,
  VENDOR_SNOWFLAKE_STATS_EXPORT: 49,
  GLOBAL_MANUFACTURER_HARVEST_REPORT: 50,
  SUPPORT_TICKET_REPORT: 51,
  FSA_VENDOR_THUMBNAIL_COVERAGE_REPORT: 52,
};

const EXPORT_TYPE_LABELS = {
  [ExportType.PRODUCT_EXPORT]: 'Product Export',
  [ExportType.TAXONOMY_EXPORT]: 'Taxonomy Export',
  [ExportType.ATTRIBUTE_EXPORT]: 'Attribute Export',
  [ExportType.ATTRIBUTE_IMPORT_ERRORS]: 'Attribute Import Errors',
  [ExportType.PRIORITY_EXPORT]: 'Priority Export',
  [ExportType.FSA_SKU_MAPPINGS_EXPORT]: 'FSA SKU Mapping Export',
  [ExportType.ALL_ATTRIBUTE_EXPORT]: 'All Attribute Export',
  [ExportType.BRAND_WITH_UPB_SCORES_EXPORT]: 'Brand with UPB Scores Export',
  [ExportType.BRAND_DETAILS_EXPORT]: 'Brand Details Export',
  [ExportType.MANUFACTURER_DETAILS_EXPORT]: 'Manufacturer Details Export',
  [ExportType.UPB_MATCH_PERCENTAGE_EXPORT]: 'UPB Match Percentage Export',
  [ExportType.SCHEMA_ATTRIBUTES_EXPORT]: 'Schema Attribute Export',
  [ExportType.PRODUCT_OUTLIER_CHANGES_EXPORT]: 'Product Outlier Changes Export',
  [ExportType.DATA_SOURCE_PREPROCESSED_EXPORT]: 'Data Source Preprocessed Export',
  [ExportType.ONE_TIME_EXPORT]: 'One Time Export',
  [ExportType.BRAND_ACTIVITY_REPORT_EXPORT]: 'Brand Activity Report Export',
  [ExportType.CD_THUMBNAIL_EXPORT]: 'CnD Thumbnail Export',
  [ExportType.VENDOR_DETAILS_EXPORT]: 'Distributor Details Export',
  [ExportType.MANUFACTURER_PORTAL_PRODUCT_EXPORT]: 'Manufacturer Portal Request Products Export',
  [ExportType.BRAND_CONTENT_QA_REPORT]: 'Brand Content QA Report Export',
  [ExportType.USER_TIME_LOGS_REPORT]: 'User Time Log Report Export',
  [ExportType.SIMILAR_BRAND_NAMES_QA_REPORT]: 'Similar Brand Names QA Report Export',
  [ExportType.MANUFACTURER_BRAND_PRODUCT_EXPORT]: 'Manufacturer Brand Products Export',
  [ExportType.GDSN_MANUFACTURER_PRODUCT_EXPORT]: 'GDSN Manufacturer Products Export',
  [ExportType.PRODUCT_LIST_UNASSIGNED_ATTRIBUTES_EXPORT]:
    'Product List Unassigned Attributes Export',
  [ExportType.MANUFACTURER_SKU_CLEAN_UP_REPORT]: 'Manufacturer SKU Clean Up Report Export',
  [ExportType.MANUFACTURER_PRODUCT_ENRICHMENT]: 'Manufacturer Product Enrichment Sources Export',
  [ExportType.USER_PAYMENT_INFO_REPORT]: 'User Payment Info Report Export',
  [ExportType.USER_THROUGHPUT_REPORT]: 'User Throughput Report Export',
  [ExportType.USER_INVOICE_REPORT]: 'User Invoice Report Export',
  [ExportType.ENGAGED_MANUFACTURER_SCORES_EXPORT]: 'Engaged Manufacturer Scores Export',
  [ExportType.MANUFACTURERS_GLN_STATUS_ASSOCIATED_WITH_A_VENDOR]:
    'Manufacturers GLN Status Associated with a Distributor Export',
  [ExportType.PRODUCT_DATA_WITH_GMV_AND_MAPPING]: 'Product Data with GMV and Mapping Export',
  [ExportType.BRAND_DP_PRODUCTS_REPORT]: 'Brand DP Products Report Export',
  [ExportType.ENGAGED_MANUFACTURERS_GMV_REPORT]: 'Engaged Manufacturers GMV Report Export',
  [ExportType.DISTRIBUTORS_GMV_REPORT]: 'Distributors GMV Report Export',
  [ExportType.UNMAPPED_GMV_PRODUCTS_REPORT]: 'Unmapped GMV Products Report Export',
  [ExportType.UNSTRUCTURED_GMV_PRODUCTS_REPORT]: 'Unstructured GMV Products Report Export',
  [ExportType.L4_LARGE_CATEGORIES_EXPORT]: 'L4 Large Categories (500+ Products) Export',
  [ExportType.L4_CATEGORY_PRODUCTS_EXPORT]: 'L4 Category Products Export',
  [ExportType.MANUFACTURER_ENGAGEMENT_REPORT]: 'Manufacturer Engagement Report Export',
  [ExportType.MFR_SCORE_GAP_REPORT]: 'Manufacturer Score Gap Report Export',
  [ExportType.MFR_SCORE_GAP_CUSTOMER_REPORT]: 'Manufacturer Score Gap (Customer) Report Export',
  [ExportType.L4_SEGMENTATION_VIEW_EXPORT]: 'L4 Segmentation View Table Export',
  [ExportType.L4_RESEGMENTATION_VIEW_EXPORT]: 'L4 Re-segmentation View Table Export',
  [ExportType.L4_RESEGMENTATION_ERROR_REPORT]: 'L4 Re-segmentation Cluster Conflict Report',
  [ExportType.VENDOR_SNOWFLAKE_STATS_EXPORT]: 'DP Partner Snowflake Stats Export',
  [ExportType.GLOBAL_MANUFACTURER_HARVEST_REPORT]: 'Global Manufacturer Harvest Report Export',
  [ExportType.SUPPORT_TICKET_REPORT]: 'Support Ticket Report Export',
  [ExportType.FSA_VENDOR_THUMBNAIL_COVERAGE_REPORT]: 'FSA Vendor Thumbnail Coverage Report Export',
};

export default ExportType;
export { EXPORT_TYPE_LABELS };
